import { useAuth } from "m2m-components/storage/useM2mAuth"
import { RouteObject, useRoutes } from "react-router-dom"
import { protectedRoutes } from "./protected"
import { publicRoutes } from "./public"
import { ScrollToTopOnPageChange } from "@/components/ScrollToTopOnPageChange/ScrollToTopOnPageChange"

const modifyRoutes = (routes: RouteObject[]) => {
    return routes.map(route => {
        return {
            ...route,
            element: (
                <>
                    <ScrollToTopOnPageChange />
                    {route.element}
                </>
            )
        }
    })
}

export const AppRoutes = () => {
    const { authenticated } = useAuth()

    const routes = modifyRoutes(authenticated ? protectedRoutes : publicRoutes)

    const element = useRoutes(routes)

    return element
}
